import scrollTo from 'utils/scrollTo';

class Freeform {
  props: Record<string, unknown>;
  node: HTMLElement;
  messageNode: HTMLElement | null;

  constructor(node: HTMLElement, options: Record<string, unknown> = {}) {
    this.props = {
      ...options,
    };

    this.node = node;

    this.messageNode = this.node.querySelector<HTMLElement>(
      '.freeform-form-has-errors, .ff-form-success'
    );

    if (this.messageNode) {
      this.init();
    }
  }

  init = () => {
    scrollTo(this.messageNode!, { alignTop: true, offset: 140 });
  };
}

export default (node: HTMLElement, props?: Record<string, unknown>) =>
  new Freeform(node, props);
